import { NOT_APPLICABLE } from "constants/global";

export default function textOrUnknown(value: any): boolean | string {
  if (typeof value === "boolean") return value;

  return value || NOT_APPLICABLE;
}
